export default __webpack_public_path__ + "static/media/viewability.54e79e27.svg";